module.exports = __webpack_public_path__ + "img/button-refresh-arrow.9b991ad8.svg";